import { create } from "zustand";
import { api } from "../services/api";
import type { StudentContext, StudentType, StudentGrade } from "../config/featureVisibility";

interface ProfileState {
  studentContext: StudentContext | null;
  loaded: boolean;
  fetchProfile: () => Promise<void>;
}

export const useProfileStore = create<ProfileState>()((set, get) => ({
  studentContext: null,
  loaded: false,

  fetchProfile: async () => {
    if (get().loaded) return;
    try {
      const res = await api.get<{
        profile: {
          studentType: string;
          grade: string | null;
          internationalProfile: unknown | null;
        } | null;
      }>("/onboarding/profile");

      if (res.profile) {
        set({
          studentContext: {
            studentType: (res.profile.studentType || "UNDERGRADUATE") as StudentType,
            grade: (res.profile.grade as StudentGrade) || null,
            isInternational: !!res.profile.internationalProfile,
          },
          loaded: true,
        });
      } else {
        set({ loaded: true });
      }
    } catch {
      set({ loaded: true });
    }
  },
}));
